import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import PropTypes from 'prop-types';

import RichText from '../../Core/RichText';
import Link from '../../Core/Link';

import { DisclaimerWrapper } from './styles';

// * Disclaimer options
const disclaimerOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
    [INLINES.HYPERLINK]: (node, children) => {
      const { data } = node;
      return (
        <Link className="rich-text-link" to={data.uri} fontSize="inherit">
          {children}
        </Link>
      );
    },
  },
};

const Disclaimer = ({ data, color = '', alignment = '' }) => {
  if (!data) return null;

  return (
    <DisclaimerWrapper color={color} alignment={alignment}>
      <RichText document={data} options={disclaimerOptions} />
    </DisclaimerWrapper>
  );
};

Disclaimer.propTypes = {
  data: PropTypes.shape().isRequired,
  color: PropTypes.string,
  alignment: PropTypes.string,
};

export default Disclaimer;
